import type { AddFlagProps } from '@databases/flags/types';

import { messages } from './i18n';
import { MentionBuilder } from './mentionBuilder';
import { MentionBuilderCriteria, BuildProps } from './types';

export class MentionFlagForSingleUser implements MentionBuilder {
  shouldShowFlag({ usersWithAccess }: MentionBuilderCriteria): boolean {
    return usersWithAccess.length === 1;
  }
  build({ formatMessage, usersWithAccess }: BuildProps): AddFlagProps {
    const { displayName, profilePicture } = usersWithAccess[0];

    return {
      profilePicture,
      title: formatMessage(
        messages['mention-notification.flag-mention-notification-title-one-user'],
        { displayName }
      ),
      description: formatMessage(
        messages['mention-notification.flag-mention-notification-description']
      ),
    };
  }
}
